import { LOGGED_OUT } from 'actions/types';
import * as types from '../actions/types';
export const initialState = {
    transactions: [],
    lastTransactionsFetchTimestamp: undefined,
    lastSpacesInfoFetchTimestamp: undefined,
    isFetchingSpacesInfo: true,
};
const exportDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_EXPORT_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactions: action.payload.transactions,
                lastTransactionsFetchTimestamp: Date.now(),
            };
        case types.SET_LAST_SPACES_INFO_FETCH_TIMESTAMP:
            return { ...state, lastSpacesInfoFetchTimestamp: action.payload };
        case types.SET_IS_FETCHING_SPACES_INFO:
            return { ...state, isFetchingSpacesInfo: action.payload };
        case LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default exportDataReducer;
